import { Alert, Badge } from "@/shared/components/MDX/MDXComponents";

# 🛠️ راهنمای ویرایشگر ساختار محصول (BOM Builder)

پلتفرم کارخانه‌سازی میمزاد (Mimzad Manufacturing Platform) — سند راهنمای کاربری

<Badge type="gold">سند استاندارد کاربری</Badge> <Badge>راهنمای جامع</Badge>

## 📋 معرفی ویرایشگر BOM

این محیط، ابزار تخصصی و حرفه‌ای مهندسی ساخت است که امکان تعریف سلسله‌مراتب درختی قطعات و مواد تشکیل‌دهنده یک محصول را فراهم می‌کند. هر محصول می‌تواند شامل چندین زیرمجموعه (Sub-assembly) و قطعه پایه (Component) باشد.

### چگونگی استفاده از ویرایشگر:

1. **لیست قطعات موجود:** در سمت راست صفحه، لیست تمام آیتم‌های موجود در انبار (مانند پیچ‌ها، ورق‌ها، قطعات الکترونیکی و فرمولاسیون‌ها) به همراه جستجو در دسترس است.
2. **ساختار درختی (درختواره):** ساختار محصول در سمت چپ نشان داده می‌شود.
3. **افزودن قطعات:** با کلیک روی دکمه `➕` در کنار هر آیتم در لیست سمت راست، می‌توانید آن قطعه را به گره (Node) فعال در سمت چپ اضافه کنید.
4. **انتخاب گره فعال:** برای ساخت قطعات فرعی (Sub-assembly)، کافیست روی نام قطعه والد در ساختار درختی کلیک کنید تا انتخاب شود، سپس قطعات فرزند را به آن اضافه کنید.

<Alert type="warning">
  ویرایشگر ساختار محصول قابلیت استفاده از `Drag & Drop` را برای سازماندهی بهتر قطعات در درخت فراهم می‌کند. دقت کنید که ساختار تعریف‌شده در این صفحه مستقیماً برای برآورد هزینه‌ها و کسر مواد در حین تولید استفاده خواهد شد.
</Alert>
